import BusinessPolicy from './Policy'

export default BusinessPolicy
